import {Injectable} from "@angular/core";
import {NavigationService} from "~/app/core/navigation.service";
import {SettingsService} from "~/app/core/settings.service";
import {StorageService} from "~/app/core/storage.service";
import {Settings} from "~/app/core/model/settings";
import {Capacitor} from "@capacitor/core";
import {ActionPerformed, LocalNotifications, LocalNotificationSchema} from "@capacitor/local-notifications";

@Injectable()
export class NotificationService {
    private web: boolean = false;
    private registeredPushNotifications: boolean = false;

    private get settings(): Settings {
        return this.settingsService.loadSettings();
    }

    constructor(
        private readonly nav: NavigationService,
        private readonly settingsService: SettingsService,
        private readonly storage: StorageService

    ) {
        // nothing
        this.web = Capacitor.getPlatform() === "web";
        LocalNotifications.addListener('localNotificationReceived', (notification: LocalNotificationSchema) => {
            console.log("localNotificationReceived");
            console.log(notification);
        });
        LocalNotifications.addListener('localNotificationActionPerformed', (notificationAction: ActionPerformed) => {
            console.log("localNotificationActionPerformed");
            console.log(notificationAction);
        });
    }

    getPushToken(): Promise<string> {
        return Promise.resolve("");
    }

    isAllowNotification(): Promise<boolean> {
        return Promise.resolve(false);
    }

    requestNotificationPermission(): Promise<boolean> {
        return Promise.resolve(false);
    }

    registerPushNotifications() {
    }

    // postNotification(options: NotificationOptions): Promise<void> {
        // const notifications: ScheduleOptions = {
        //     notifications: [
        //         {
        //             title: options.title,
        //             body: options.body,
        //             largeBody: options.largeBody,
        //
        //             id: options.id,
        //             schedule: {
        //                 at: new Date(),
        //                 count: 1,
        //                 allowWhileIdle: true,
        //             },
        //             attachments: null,
        //             extra: options.extra,
        //         }
        //     ]
        // };
        //
        // if (this.web) {
        //     return new Promise((resolve, reject) => {
        //         LocalNotifications.requestPermissions().then((permissionStatus) => {
        //             if (permissionStatus.display === 'granted') {
        //                 LocalNotifications.schedule(notifications).then(value => {
        //                     resolve();
        //                 }, (error) => {
        //                     reject(error);
        //                 });
        //             } else {
        //                 reject();
        //             }
        //         }, (error) => reject(error));
        //     });
        // } else {
        //     return new Promise((resolve, reject) => {
        //         LocalNotifications.requestPermissions().then((permissionStatus) => {
        //             if (permissionStatus.display !== 'denied') {
        //                 LocalNotifications.schedule(notifications).then(value => {
        //                     resolve();
        //                 }, (error) => {
        //                     reject(error);
        //                 });
        //             } else {
        //                 reject();
        //             }
        //         }).catch(error => {
        //             reject(error);
        //         });
        //     });
        // }
    // }
}
